import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS } from '../../utils/log';
import GlobalFilterPanel, {FILTER_PERIOD_GROUP} from '../filter/GlobalFilterPanel';
import ENUMS ,{FilingTypeEnum} from '../../utils/enums';

const log = new Logger('OPEN_RETURNS_FILTERPANEL', LOG_LEVELS.DEBUG);

export class OpenReturnsFilterPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selection: {},
      disableSearch: true
    };
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    this.selectionHandler = this.selectionHandler.bind(this);
    this.onCustomDatesClick = this.onCustomDatesClick.bind(this);
  }

  onSearchClickHandler(selection) {
    log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
    log.debug('onSearchClickHandler(): selection: ', selection);
    let combinedSelection = Object.assign({}, this.state.selection, selection);
    log.debug('onSearchClickHandler(): combinedSelection: ', combinedSelection);
    this.props.onSearchClick(combinedSelection);
  }

  selectionHandler(keyValuePairs) {
    log.debug('selectionHandler(): keyValuePairs: ', keyValuePairs);
    let key =  Object.keys(keyValuePairs)[0];
    let value =  Object.values(keyValuePairs)[0];
    let selection = Object.assign({}, this.state.selection);
    //Always reset countryCode when company is changed    
    if(keyValuePairs.hasOwnProperty('companyId')) {
      delete selection.countryCode;
    }
    if(_.isEmpty(value)) {
      delete selection[key];
    } else {
      selection = Object.assign(selection, keyValuePairs);
    }
    let disableSearch = _.isEmpty(selection);
    this.setState({
      selection: selection,
      disableSearch: disableSearch
    });
  }

  onCustomDatesClick() {
    log.debug('onCustomDatesClick: ');
      if(typeof this.props.onCustomDatesClick === 'function')
          this.props.onCustomDatesClick();
  }

  render() {
    let filingTypes = _.filter(ENUMS.GetAllEnumOptions(FilingTypeEnum),function(t){ return t !== FilingTypeEnum.EXTRASTAT})
    log.debug('render(): ', this.props);
    return (
      <s-box name="filter-panel" class="skylab2 pad-bottom-none" data-testid="component-open-returns-filter-panel" data-test="component-open-returns-filter-panel" >
          <GlobalFilterPanel 
            countries={this.props.countryList} 
            companies={this.props.companyList}
            onSearchClick={this.onSearchClickHandler} 
            disableSearch={this.state.disableSearch} 
            hideElements={
              {
                month: true,
                year: true,
                startDate: true,
                endDate: true
              }
            }
            companySelectValueLanguageStringKey="global_All"
            countrySelectValueLanguageStringKey="global_All"
            filterPeriodGroup={FILTER_PERIOD_GROUP.MONTH_YEAR}
            monthSelectValueLabelKey='All'
            showCustomDatesLink={true}
            showXmonthPicker={true}
            onCustomDatesClick={this.onCustomDatesClick}
            filteredReturnTypes={filingTypes}
            showPrevNextMonth={true}
          >
          </GlobalFilterPanel>

          <div className="clear"></div>
      </s-box>
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);  
  return {
    languages: state.languages
  };
}


OpenReturnsFilterPanel.defaultProps = {
  filterOptions: {},
  onSearchClick: () => {},
  companyList: [],
  onCustomDatesClick: () => {}
};

export default connect(mapStateToProps)(OpenReturnsFilterPanel);